import { useMemo } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export function getAuthPhotoUrl(src) {
  if (!src) return null;
  if (src.startsWith('data:') || src.startsWith('http')) return src;
  if (src.startsWith('/api/')) {
    const token = localStorage.getItem('token');
    return `${API_URL}${src}${src.includes('?') ? '&' : '?'}token=${token}`;
  }
  // Cas base64 brut sans préfixe data: (legacy) → ajouter le préfixe pour rendre l'image valide
  if (/^[A-Za-z0-9+/=_-]{40,}$/.test(src.slice(0, 100))) {
    return `data:image/jpeg;base64,${src}`;
  }
  return src;
}

const AuthImage = ({ src, alt, className, ...props }) => {
  const authSrc = useMemo(() => getAuthPhotoUrl(src), [src]);
  if (!authSrc) return null;
  return <img src={authSrc} alt={alt} className={className} {...props} />;
};

export default AuthImage;
